module.exports = __webpack_public_path__ + "img/email-header-personalgrowth@2x.81f35cf4.png";